import { useEffect, useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from '@nextui-org/react';
import { fetchOneAutomatedOffers } from 'common/src/api/automated-offers';

interface Tasker {
  name: string;
  last_name: string;
  email: string;
  phone_number: string;
  is_assigned: boolean;
}

interface Props {
  automated_task_offer_id: number;
}

const AutomatedOfferViewer = ({ automated_task_offer_id }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [taskers, setTaskers] = useState<Tasker[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTaskers = async () => {
      try {
        const { data, error } = await fetchOneAutomatedOffers(automated_task_offer_id);
        if (error) throw error;

        setTaskers(
          // TODO agregar interfaz
          data?.map((d: any) => ({
            name: d.tasker.name,
            last_name: d.tasker.last_name,
            email: d.tasker.email,
            phone_number: d.tasker.phone_number,
            is_assigned: d.tasker.assigned_taskers?.some(
              (assignment: any) => assignment.task_id === d.automated_task_offer.task_id
            ),
          })) || []
        );

        setLoading(false);
      } catch (err) {
        console.error(err);
        setError('Error al cargar los taskers');
        setLoading(false);
      }
    };

    fetchTaskers();
  }, [automated_task_offer_id]);

  if (loading) return null;
  if (error) return <div>{error}</div>;
  if (taskers.length === 0) return null;

  return (
    <>
      <Button onPress={onOpen} variant="light" className="text-primary">
        Se ha ofrecido a {taskers.length} taskers
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="3xl"
        classNames={{
          base: 'my-8',
          body: 'max-h-[70vh] overflow-y-auto',
        }}
      >
        <ModalContent>
          <ModalHeader>Taskers Ofrecidos</ModalHeader>
          <ModalBody>
            <Table aria-label="Tabla de taskers">
              <TableHeader>
                <TableColumn>Nombre</TableColumn>
                <TableColumn>Apellido</TableColumn>
                <TableColumn>Email</TableColumn>
                <TableColumn>Teléfono</TableColumn>
                <TableColumn>Tasker Asignado</TableColumn>
              </TableHeader>
              <TableBody>
                {taskers.map((tasker, index) => (
                  <TableRow key={index}>
                    <TableCell>{tasker.name}</TableCell>
                    <TableCell>{tasker.last_name}</TableCell>
                    <TableCell>{tasker.email}</TableCell>
                    <TableCell>{tasker.phone_number}</TableCell>
                    <TableCell>
                      <span
                        className={`px-2 py-1 rounded-full ${
                          tasker.is_assigned
                            ? 'bg-success-100 text-success-600 font-bold'
                            : 'bg-default-100'
                        }`}
                      >
                        {tasker.is_assigned ? 'Sí' : 'No'}
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AutomatedOfferViewer;
